// extracted by mini-css-extract-plugin
export default {"header":"header--b6lzC","avatar":"avatar--m6q2P","statusContainer":"statusContainer--DQWEv","status":"status--brsFx","text":"text--ZbSoV","main":"main--YFHHo"};